import React, { useEffect, useState } from "react";
import {
	FilterButton,
	Modal,
	Pagination,
	SidebarModal,
	Table,
	Tag
} from "components";
import EntityContainer from "modules/entity/containers";
import { helpers } from "services";
import qs from "qs";
import get from "lodash/get";
import StoreActions from "store/actions/system";
import { useDispatch, useSelector } from "react-redux";
import Filter from "pages/Reports/reportOrders/filter";
import isEmpty from "lodash/isEmpty";
import DateFilterWrap from "components/DateFilter/wrap";
import config from "config";
import useTranslation from "hooks/useTranslation";
import Detail from "pages/Reports/reportOrders/detail";
import DownloadFile from "components/DownloadFile";
import { useLocation, useNavigate } from "react-router-dom";

function MainOrganizationOrders() {
	const location = useLocation();
	const navigate = useNavigate();
	const { tr } = useTranslation();

	const defaultCurrency = useSelector(
		state => state.auth.default_currency_code
	);
	const [filterModal, showFilterModal] = useState(false);
	const [selected, setSelected] = useState(null);
	const [detailInfo, showDetailInfo] = useState(false);

	const params = qs.parse(location.search, { ignoreQueryPrefix: true });
	const { page, start_at, end_at, ...others } = params;
	const dateRange = helpers.getReportExtraDateRange({
		start_at,
		end_at,
		params,
		sidebarKeys: helpers.REPORT_ORDERS_SIDEBAR_KEYS
	});
	const dispatch = useDispatch();
	const handlePageClick = selected => {
		const search = { ...params, page: selected + 1 };

		navigate({
			search: qs.stringify(search)
		});
	};

	useEffect(() => {
		dispatch(StoreActions.SetToolbarTitle(tr("Список заказов")));
	}, []);

	return (
		<div className="d-panel">
			<Modal
				size={700}
				isOpen={detailInfo}
				toggle={() => showDetailInfo(false)}
			>
				<Detail {...{ selected }} />
			</Modal>

			<SidebarModal
				size={400}
				isOpen={filterModal}
				toggle={() => showFilterModal(false)}
			>
				<Filter {...{ showFilterModal }} />
			</SidebarModal>

			<div className="d-flex align-items-center justify-content-between mb-10">
				<div className="main-title mb-0">{tr("Заказы")}</div>
				<div className="d-flex align-items-center">
					<DateFilterWrap
						className="mr-10"
						dropdownPosition={"right"}
						initialDefault={"month"}
						withStartHoursAppended={true}
						navigateByDay={true}
					/>
					<FilterButton
						hasFilter={!isEmpty(others)}
						className={""}
						handleClick={() => showFilterModal(true)}
					/>
					<DownloadFile
						api={"/reports/orders"}
						params={{
							include: "goods",
							sort: helpers.REPORT_LIST_SORT,
							limit: 20,
							page,
							extra: {
								_excel: "1",
								product_ids: params.dishes
									? params.dishes
										.split(",")
										.reduce((prev, curr) => [...prev, curr.split("/")[0]], [])
										.join(",")
									: "",
								payment_type_ids: params.paymentTypes
									? params.paymentTypes
										.split(",")
										.reduce((prev, curr) => [...prev, curr.split("/")[0]], [])
										.join(",")
									: "",
								...dateRange
							},
							filter: {
								type: params.type ? params.type : "",
								client_id: params.client ? params.client.split("/")[0] : "",
								status: params.status ? params.status : "",
								order_number: params.orderNumber ? params.orderNumber : "",
								user_id: params.author ? params.author.split("/")[0] : ""
							}
						}}
						filename={"Заказы.xlsx"}
					/>
				</div>
			</div>
			<EntityContainer.All
				entity="report-order"
				name={`all`}
				url="/main/reports/orders"
				primaryKey="id"
				params={{
					include: "goods",
					sort: helpers.REPORT_LIST_SORT,
					limit: 20,
					page,
					extra: {
						product_ids: params.dishes
							? params.dishes
								.split(",")
								.reduce((prev, curr) => [...prev, curr.split("/")[0]], [])
								.join(",")
							: "",
						payment_type_ids: params.paymentTypes
							? params.paymentTypes
								.split(",")
								.reduce((prev, curr) => [...prev, curr.split("/")[0]], [])
								.join(",")
							: "",
						...dateRange
					},
					filter: {
						type: params.type ? params.type : "",
						client_id: params.client ? params.client.split("/")[0] : "",
						status: params.status ? params.status : "",
						order_number: params.orderNumber ? params.orderNumber : "",
						user_id: params.author ? params.author.split("/")[0] : ""
					}
				}}
			>
				{({ items, isFetched, meta }) => {
					return (
						<div className="with-pagination with-bg">
							<Table
								items={items}
								isFetched={isFetched}
								rowKey="id"
								onRowClick={item => {
									setSelected(item);
									showDetailInfo(true);
								}}
								columns={[
									{
										title: tr("ID заказа"),
										dataIndex: "id",
										className: "w-[80px]",
										render: value => <div>{value}</div>
									},
									{
										title: tr("Организация"),
										className: "w-[80px]",
										render(value, record) {
											return get(record, "organization.name");
										}
									},
									{
										title: tr("ID заказа"),
										dataIndex: "id",
										className: "w-[80px]",
										render: value => <div>{value}</div>
									},
									{
										title: tr("№ заказа"),
										dataIndex: "order_number",
										className: "w-100",
										render: value => <div>{value}</div>
									},
									{
										title: tr("Дата"),
										dataIndex: "created_at",
										isClickable: true,
										render: (value, row) => (
											<div>
												<div>
													{helpers.formatDate(value, "DD.MM.YYYY / HH:mm")}
												</div>
											</div>
										)
									},
									{
										title: tr("Тип"),
										dataIndex: "type",
										render: value => (
											<div className="ws-no-wrap fw-500">
												{helpers.getOrderType(value, tr)}
											</div>
										)
									},
									{
										title: tr("Кассир"),
										dataIndex: "user",
										render: value => (
											<div>
												{value ? (
													value.name
												) : (
													<span style={{ opacity: "0.4" }}>{tr("не указан")}</span>
												)}
											</div>
										)
									},
									{
										title: tr("Клиент"),
										dataIndex: "client",
										render: value => (
											<div>
												{value ? (
													value.name
												) : (
													<span style={{ opacity: "0.4" }}>-</span>
												)}
											</div>
										)
									},
									{
										title: tr("Цена места"),
										dataIndex: "place_price",
										className: "ws-no-wrap",
										render: value => (
											<div>
												{helpers.convertToReadable(value ? Number(value) : 0)}{" "}
												{defaultCurrency && defaultCurrency.toUpperCase()}
											</div>
										)
									},
									{
										title: tr("Цена доставки"),
										dataIndex: "delivery_price",
										className: "ws-no-wrap",
										render: value => (
											<div>
												{helpers.convertToReadable(value ? Number(value) : 0)}{" "}
												{defaultCurrency && defaultCurrency.toUpperCase()}
											</div>
										)
									},
									{
										title: tr("Цена обслуживания"),
										dataIndex: "tip_price",
										className: "ws-no-wrap",
										render: value => (
											<div>
												{helpers.convertToReadable(value ? Number(value) : 0)}{" "}
												{defaultCurrency && defaultCurrency.toUpperCase()}
											</div>
										)
									},
									{
										title: tr("Цена всего"),
										dataIndex: "price",
										className: "ws-no-wrap",
										render: (value, row) => {
											return (
												<div className={"fw-700"}>
													{helpers.convertToReadable(value ? Number(value) : 0)}{" "}
													{defaultCurrency && defaultCurrency.toUpperCase()}
												</div>
											);
										}
									},
									{
										title: tr("Тип оплаты"),
										dataIndex: "transactions",
										render: value => {
											return (
												<div>
													{value.map(item => {
														const val = item.value;
														return (
															item.type === config.TRANSACTION_TYPE_INCOME && (
																<div className="d-flex justify-content-between">
																	<span className="ws-no-wrap lh-28">
																		{get(item, "payment_type.name")}
																	</span>
																	<span className="lh-28 ml-10 ws-no-wrap --light-text-color">
																		{val
																			? helpers.convertToReadable(Number(val))
																			: "0"}
																		{defaultCurrency &&
																			defaultCurrency.toUpperCase()}
																	</span>
																</div>
															)
														);
													})}
												</div>
											);
										}
									},
									{
										title: tr("Статус"),
										dataIndex: "status",
										isClickable: true,
										className: "",
										render: (value, row) => (
											<div className="divider-wrapper">
												<Tag color={helpers.getOrderStatus(value, tr).color}>
													{helpers.getOrderStatus(value, tr).label}
												</Tag>
											</div>
										)
									}
								]}
							/>

							{get(meta, "pageCount", 1) > 1 && (
								<Pagination
									pageCount={get(meta, "pageCount", 1)}
									currentPage={page ? Number(page) : 1}
									handlePageClick={handlePageClick}
								/>
							)}
						</div>
					);
				}}
			</EntityContainer.All>
		</div>
	);
}

export default MainOrganizationOrders;
